<template>
  <div class="mt-2">
    <Header />
    <Tabla />
  </div>
</template>
<script>
import { defineAsyncComponent } from 'vue'
export default {
  name: 'verIncidentes',
  components: {
    Tabla: defineAsyncComponent(
      () => import('./componentsIncidentes/Tabla.vue')
    ),
    Header: defineAsyncComponent(
      () => import('./componentsIncidentes/Header.vue')
    )
  }
}
</script>
<style scoped>

</style>
